module.exports = __webpack_public_path__ + "img/5.400e3370.jpg";